import type {
  ApolloCache,
  DefaultContext,
  DocumentNode,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  TypedDocumentNode,
} from '@apollo/client';
import { useEffect } from 'react';
import { useMutation } from '@apollo/client';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { loggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';

import { logGraphqlError } from './logGraphqlError';

export function useMutationWithErrorLogging<
  TData = unknown,
  TVariables = OperationVariables,
  TContext = DefaultContext,
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables, TContext>,
): MutationTuple<TData, TVariables, TContext, ApolloCache<unknown>> {
  const resp = useMutation(mutation, options);
  const advisorId = loggedInAsAdvisorID();
  const auth = useAuth();

  useEffect(() => {
    if (resp[1].error) {
      logGraphqlError(mutation, resp[1].error, { userId: auth.user?.id, advisorId });
    }
  }, [resp[1].error]);
  return resp;
}
